module.exports = __webpack_public_path__ + "img/selected2-min.b4021925.png";